<template>
    <button
        class="category-label-select-wrapper__category-label"
    >
        {{category.name}}
    </button>
</template>

<script>

export default {
    name: 'category-label',
    props: {
        category: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
    async mounted () {
    },
    created () {
    },
    watch: {
    },
    validations: {
    }
}
</script>

<style lang="scss" scoped>
    @import '~@/assets/css/components/_variables.scss';
</style>
